import script from "./CookieAlert.vue?vue&type=script&lang=js"
export * from "./CookieAlert.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__